import { render } from "./CrossStep4Completato.vue?vue&type=template&id=45b1f182"
import script from "./CrossStep4Completato.vue?vue&type=script&lang=js"
export * from "./CrossStep4Completato.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__